import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext(null);

const dict = {
  es: {
    nav: {
      como: "Cómo funciona",
      ejemplos: "Ejemplos",
      paquetes: "Paquetes",
      crear: "Crear canción",
      faq: "Preguntas",
      seguimiento: "Seguimiento",
      review: "Reseñas",
      admin: "Admin",
      cta: "Crear mi canción",
      ctaEmoji: "Crear mi canción 🎶",
    },
    hero: {
      badge: "Canciones personalizadas · Hechas con cariño",
      title1: "El regalo que no se compra en una tienda.",
      title2: "Se crea con su historia.",
      desc: "Cuéntanos sus recuerdos, nombres y momentos especiales. Nosotros los convertimos en una canción personalizada hecha especialmente para esa persona.",
      features: ["Letra personalizada", "Voz + melodía", "Basada en tu historia", "Entrega digital en MP3"],
      price: "Desde $13.99",
      cta1: "Crear mi canción 🎶",
      listenQ: "¿Quieres escuchar cómo podría sonar?",
      listenCta: "Escuchar ejemplos",
    },
    marquee: ["Cumpleaños", "Aniversarios", "Bodas", "Declaraciones de amor", "Día de las madres", "Propuestas", "Graduaciones", "Solo porque sí"],
    how: {
      kicker: "Así de fácil",
      title: "De tu historia a una melodía en 4 pasos",
      steps: [
        { title: "Cuéntanos tu historia", text: "Completa un breve formulario: el género, la voz, la ocasión y el mensaje que quieres transmitir." },
        { title: "Escribimos la letra", text: "Nuestro equipo compone una letra original inspirada en cada detalle que nos compartiste." },
        { title: "Grabamos la melodía", text: "Producimos la canción con voz real y una melodía pensada para emocionar." },
        { title: "Recibes tu regalo", text: "Te entregamos tu canción en MP3 lista para sorprender a esa persona especial." },
      ],
    },
    pricing: {
      kicker: "Elige tu regalo",
      title: "Un paquete para cada historia",
      subtitle: "Precios en USD · Sin costos ocultos",
      popular: "Más popular",
      choose: "Elegir",
      plans: {
        plan_mini: ["Voz + melodía", "Entrega en formato MP3", "Sin revisiones de la letra"],
        plan_pro: ["Voz + melodía", "Entrega en formato MP3", "2 revisiones de la letra", "2 melodías para elegir"],
      },
      off: "30% OFF",
      before: "Antes",
      save: "¡Oferta por tiempo limitado!",
    },
    wizard: {
      kicker: "Empecemos",
      title: "Crea tu canción",
      step: "Paso",
      of: "de",
      back: "Atrás",
      next: "Siguiente",
      redirecting: "Redirigiendo...",
      pay: "Pagar y crear",
      getFree: "Obtener gratis",
      incomplete: "Por favor completa este paso para continuar.",
      payError: "No se pudo iniciar el pago. Inténtalo de nuevo.",
      generos: ["Balada", "Pop", "Regional Mexicano", "Rock", "Reggaetón", "Cumbia", "Bachata", "Salsa", "Blues", "Bolero", "Rap / Hip-Hop", "Otro"],
      q_genero: "¿Qué género musical deseas?",
      preview: "Preview",
      q_voz: "¿Prefieres voz femenina o masculina?",
      voz_f: "Voz femenina",
      voz_m: "Voz masculina",
      q_ocasion: "¿La canción es para una ocasión especial?",
      oc_si: "Sí, es especial 🎉",
      oc_no: "No en particular",
      q_cual_ocasion: "¿Cuál es la ocasión?",
      ph_ocasion: "Ej. Aniversario de bodas, cumpleaños...",
      q_nombre: "¿Quieres que aparezca el nombre de la persona?",
      nombre_si: "Sí, incluir nombre",
      nombre_no: "No, sin nombre",
      l_nombre: "Nombre de la persona",
      l_relacion: "¿Cuál es tu relación con esa persona?",
      ph_relacion: "Ej. Mi pareja, mi madre, mi mejor amigo...",
      q_mensaje: "Cuéntanos sobre la ocasión",
      sub_mensaje: "¿Qué te gustaría que expresáramos a través de la melodía?",
      ph_mensaje: "Cuéntanos la historia, los recuerdos, los detalles y el sentimiento que quieres transmitir...",
      q_paquete: "Elige tu paquete",
      q_entrega: "Velocidad de entrega y extras",
      q_contacto: "Contacto y código de afiliado",
      extras: "Extras opcionales",
      spotify_title: "Publicar en Spotify",
      spotify_desc: "Sube tu canción a Spotify y las principales plataformas",
      karaoke_title: "Video Karaoke",
      karaoke_desc: "Video con letra de la canción",
      total_label: "Total",
      d_estandar: "Entrega Estándar",
      d_rapida: "Entrega Rápida",
      d_urgente: "Entrega Urgente",
      t_estandar: "10 a 12 días",
      t_rapida: "3 a 5 días",
      t_urgente: "1 día",
      free: "Gratis",
      l_tunombre: "Tu nombre",
      l_tucorreo: "Tu correo",
      select_pkg: "Selecciona un paquete",
      l_afiliado: "¿Tienes un código de afiliado?",
      ph_afiliado: "Ingresa tu código (opcional)",
      aff_apply: "Aplicar",
      aff_valid: "¡Código válido! $1 de descuento 🎉",
      aff_invalid: "Código inválido",
      aff_discount: "Descuento afiliado",
      aff_free_valid: "¡Código 100% GRATIS aplicado! 🎉 Tu Plan Mini es gratis.",
      aff_free_restrict: "Este código gratis solo aplica al Plan Mini con entrega estándar y sin extras. Ajusta tu pedido para usarlo.",
      aff_free_label: "Código 100% gratis",
    },
    testimonials: {
      kicker: "Historias reales",
      title: "Melodías que emocionan",
      verified: "Cliente verificado",
      items: [
        { name: "María G.", text: "Le regalé una canción a mi mamá por su cumpleaños y lloró de la emoción. ¡El mejor regalo que he dado!", occasion: "Cumpleaños" },
        { name: "Carlos R.", text: "Usé la canción para pedirle matrimonio a mi novia. La letra capturó nuestra historia perfectamente.", occasion: "Propuesta" },
        { name: "Ana L.", text: "Entrega rapidísima y la calidad de la voz es increíble. Superó todas mis expectativas.", occasion: "Aniversario" },
      ],
    },
    showcase: {
      kicker: "Escucha la magia",
      title: "Ejemplos de canciones creadas",
      subtitle: "Escucha un preview corto de algunas melodías que hemos creado.",
      voice: "Voz",
      preview: "Preview 30s",
      cta: "Quiero la mía 🎶",
      unavailable: "Audio no disponible",
    },
    instagram: {
      badge: "Reto en Instagram",
      title1: "Gana",
      title2: "$5 de descuento",
      title3: "en tu próximo pedido",
      desc1: "Comparte el momento mágico: sube un video sorprendiendo a tu persona especial con su canción personalizada y etiqueta a",
      steps: [
        "Graba la reacción de tu persona especial al escuchar su canción",
        "Súbelo a Instagram y etiqueta a @ig.regalaunamelodia",
        "Recibe $5 de descuento en tu próximo pedido",
      ],
      follow: "Seguir @ig.regalaunamelodia",
    },
    faq: {
      kicker: "¿Tienes dudas?",
      title: "Preguntas frecuentes",
      items: [
        { q: "¿Cuánto tarda en llegar mi canción?", a: "Depende de la velocidad que elijas: Estándar (10 a 12 días, sin costo), Rápida (3 a 5 días, +$3.99) o Urgente (1 día, +$5.99)." },
        { q: "¿Puedo pedir cambios en la letra?", a: "Sí. El Plan Pro incluye 2 revisiones de la letra. El Plan Mini no incluye revisiones." },
        { q: "¿En qué formato recibo la canción?", a: "Todos los planes se entregan en formato MP3, listos para compartir." },
        { q: "¿Cómo realizo el pago?", a: "El pago es 100% en línea y seguro a través de Stripe. Aceptamos las principales tarjetas de crédito y débito." },
        { q: "¿La canción es realmente original?", a: "Totalmente. Cada melodía y letra se compone desde cero, inspirada únicamente en la historia que nos compartes." },
        { q: "¿Puedo dar seguimiento a mi pedido?", a: "¡Claro! Escríbenos por WhatsApp en cualquier momento y con gusto te damos seguimiento a tu pedido." },
      ],
    },
    footer: {
      title: "¿List@ para regalar una melodía?",
      desc: "Crea una canción única e inolvidable hoy mismo, o escríbenos por WhatsApp si tienes preguntas.",
      cta: "Crear mi canción",
      rights: "Hecho con",
    },
    whatsapp: "Escríbenos",
    track: {
      back: "Volver al inicio",
      title: "Seguimiento de tu pedido",
      subtitle: "Ingresa tu código para ver el estado y descargar tu canción.",
      search: "Buscar",
      code: "Código",
      client: "Cliente",
      download: "Descargar mi canción (MP3)",
      download1: "Descargar audio 1 (MP3)",
      download2: "Descargar audio 2 (MP3)",
      downloadKaraoke: "Descargar video karaoke (MP4)",
      karaokePending: "Tu video karaoke estará disponible muy pronto 🎬",
      inProduction: "Tu canción está en producción 🎶",
      comeBack: "Vuelve pronto o escríbenos por WhatsApp.",
      contact: "Contactar",
      notFound: "No se encontró el pedido.",
      status: { nuevo: "Recibido", en_proceso: "En producción", en_revision: "En revisión", entregado: "¡Lista para descargar!" },
      progressTitle: "Progreso de tu pedido",
      currentStage: "Etapa actual",
      stages: {
        pedido_realizado: "Pedido realizado",
        escribiendo_letra: "Escribiendo la letra",
        letra_entregada: "Letra entregada",
        revision_letra: "Revisión de la letra",
        letra_aprobada: "Letra aprobada",
        creando_melodia: "Creación y grabación de la melodía",
        cancion_entregada: "Canción entregada",
      },
      dlError: "Tu canción aún no está lista para descargar.",
      dlErrorKaraoke: "Tu video karaoke aún no está listo para descargar.",
    },
    success: {
      checking: "Confirmando tu pago...",
      wait: "Un momento por favor.",
      title: "¡Pago confirmado! 🎉",
      thanks: "Gracias por tu compra",
      willStart: "Comenzaremos a crear tu melodía muy pronto.",
      yourCode: "Tu código de seguimiento",
      trackLink: "Rastrear y descargar mi canción →",
      wa: "Dar seguimiento por WhatsApp",
      failTitle: "No pudimos confirmar el pago",
      failDesc: "Si crees que es un error, contáctanos por WhatsApp.",
      home: "Volver al inicio",
    },
    cancel: {
      title: "Pago cancelado",
      desc: "No te preocupes, no se realizó ningún cargo. Puedes intentarlo cuando quieras.",
      retry: "Volver a intentar",
    },
    review: {
      back: "Volver al inicio",
      title: "Déjanos tu reseña",
      subtitle: "Tu opinión aparecerá en nuestra sección de Historias reales 💕",
      code: "Código de tu pedido",
      codePh: "Ej. A1B2C3",
      codeHelp: "Encuéntralo en tu correo de confirmación o en la sección de Seguimiento.",
      codeRequired: "Ingresa el código de tu pedido",
      rating: "¿Cómo calificarías tu experiencia?",
      name: "Tu nombre",
      occasion: "Ocasión (opcional)",
      occasionPh: "Ej. Cumpleaños, Aniversario...",
      message: "Tu reseña",
      messagePh: "Cuéntanos qué te pareció tu canción...",
      submit: "Enviar mi reseña",
      required: "Escribe tu nombre y tu reseña",
      error: "No pudimos enviar tu reseña. Inténtalo de nuevo.",
      thanksTitle: "¡Gracias por tu reseña!",
      thanksText: "Tu historia ya forma parte de Regala Una Melodía. 🎶",
      goHome: "Volver al inicio",
    },
  },
  en: {
    nav: {
      como: "How it works",
      ejemplos: "Examples",
      paquetes: "Packages",
      crear: "Create song",
      faq: "FAQ",
      seguimiento: "Track order",
      review: "Reviews",
      admin: "Admin",
      cta: "Create my song",
      ctaEmoji: "Create my song 🎶",
    },
    hero: {
      badge: "Personalized songs · Made with love",
      title1: "The gift you won't find in a store.",
      title2: "It's created from their story.",
      desc: "Tell us their memories, names and special moments. We turn them into a personalized song made especially for that person.",
      features: ["Personalized lyrics", "Voice + melody", "Based on your story", "Digital MP3 delivery"],
      price: "From $13.99",
      cta1: "Create my song 🎶",
      listenQ: "Want to hear how it could sound?",
      listenCta: "Listen to examples",
    },
    marquee: ["Birthdays", "Anniversaries", "Weddings", "Love declarations", "Mother's Day", "Proposals", "Graduations", "Just because"],
    how: {
      kicker: "This easy",
      title: "From your story to a melody in 4 steps",
      steps: [
        { title: "Tell us your story", text: "Fill out a short form: the genre, the voice, the occasion and the message you want to convey." },
        { title: "We write the lyrics", text: "Our team composes original lyrics inspired by every detail you shared with us." },
        { title: "We record the melody", text: "We produce the song with real vocals and a melody designed to move you." },
        { title: "You get your gift", text: "We deliver your song in MP3, ready to surprise that special someone." },
      ],
    },
    pricing: {
      kicker: "Choose your gift",
      title: "A package for every story",
      subtitle: "Prices in USD · No hidden fees",
      popular: "Most popular",
      choose: "Choose",
      plans: {
        plan_mini: ["Vocals + melody", "Delivered in MP3 format", "No lyric revisions"],
        plan_pro: ["Vocals + melody", "Delivered in MP3 format", "2 lyric revisions", "2 melodies to choose from"],
      },
      off: "30% OFF",
      before: "Was",
      save: "Limited-time offer!",
    },
    wizard: {
      kicker: "Let's start",
      title: "Create your song",
      step: "Step",
      of: "of",
      back: "Back",
      next: "Next",
      redirecting: "Redirecting...",
      pay: "Pay and create",
      getFree: "Get it for free",
      incomplete: "Please complete this step to continue.",
      payError: "Payment could not be started. Please try again.",
      generos: ["Ballad", "Pop", "Regional Mexican", "Rock", "Reggaeton", "Cumbia", "Bachata", "Salsa", "Blues", "Bolero", "Rap / Hip-Hop", "Other"],
      q_genero: "What music genre would you like?",
      preview: "Preview",
      q_voz: "Do you prefer a female or male voice?",
      voz_f: "Female voice",
      voz_m: "Male voice",
      q_ocasion: "Is the song for a special occasion?",
      oc_si: "Yes, it's special 🎉",
      oc_no: "Not really",
      q_cual_ocasion: "What is the occasion?",
      ph_ocasion: "E.g. Wedding anniversary, birthday...",
      q_nombre: "Do you want the person's name in the song?",
      nombre_si: "Yes, include name",
      nombre_no: "No, without name",
      l_nombre: "Person's name",
      l_relacion: "What is your relationship with that person?",
      ph_relacion: "E.g. My partner, my mother, my best friend...",
      q_mensaje: "Tell us about the occasion",
      sub_mensaje: "What would you like us to express through the melody?",
      ph_mensaje: "Tell us the story, the memories, the details and the feeling you want to convey...",
      q_paquete: "Choose your package",
      q_entrega: "Delivery speed and extras",
      q_contacto: "Contact and affiliate code",
      extras: "Optional extras",
      spotify_title: "Publish on Spotify",
      spotify_desc: "Upload your song to Spotify and major platforms",
      karaoke_title: "Karaoke Video",
      karaoke_desc: "Video with the song lyrics",
      total_label: "Total",
      d_estandar: "Standard Delivery",
      d_rapida: "Fast Delivery",
      d_urgente: "Urgent Delivery",
      t_estandar: "10 to 12 days",
      t_rapida: "3 to 5 days",
      t_urgente: "1 day",
      free: "Free",
      l_tunombre: "Your name",
      l_tucorreo: "Your email",
      select_pkg: "Select a package",
      l_afiliado: "Have an affiliate code?",
      ph_afiliado: "Enter your code (optional)",
      aff_apply: "Apply",
      aff_valid: "Valid code! $1 off 🎉",
      aff_invalid: "Invalid code",
      aff_discount: "Affiliate discount",
      aff_free_valid: "100% FREE code applied! 🎉 Your Mini Plan is free.",
      aff_free_restrict: "This free code only applies to the Mini Plan with standard delivery and no extras. Adjust your order to use it.",
      aff_free_label: "100% free code",
    },
    testimonials: {
      kicker: "Real stories",
      title: "Melodies that move you",
      verified: "Verified customer",
      items: [
        { name: "María G.", text: "I gave my mom a song for her birthday and she cried with joy. The best gift I've ever given!", occasion: "Birthday" },
        { name: "Carlos R.", text: "I used the song to propose to my girlfriend. The lyrics captured our story perfectly.", occasion: "Proposal" },
        { name: "Ana L.", text: "Super fast delivery and the vocal quality is incredible. It exceeded all my expectations.", occasion: "Anniversary" },
      ],
    },
    showcase: {
      kicker: "Hear the magic",
      title: "Examples of songs we've created",
      subtitle: "Listen to a short preview of some of the melodies we've created.",
      voice: "Voice",
      preview: "Preview 30s",
      cta: "I want mine 🎶",
      unavailable: "Audio unavailable",
    },
    instagram: {
      badge: "Instagram challenge",
      title1: "Get",
      title2: "$5 off",
      title3: "your next order",
      desc1: "Share the magical moment: upload a video surprising your special someone with their personalized song and tag",
      steps: [
        "Record your special someone's reaction to their song",
        "Upload it to Instagram and tag @ig.regalaunamelodia",
        "Get $5 off your next order",
      ],
      follow: "Follow @ig.regalaunamelodia",
    },
    faq: {
      kicker: "Have questions?",
      title: "Frequently asked questions",
      items: [
        { q: "How long does my song take to arrive?", a: "It depends on the speed you choose: Standard (10 to 12 days, free), Fast (3 to 5 days, +$3.99) or Urgent (1 day, +$5.99)." },
        { q: "Can I request changes to the lyrics?", a: "Yes. The Pro Plan includes 2 lyric revisions. The Mini Plan includes no revisions." },
        { q: "What format do I receive the song in?", a: "All plans are delivered in MP3 format, ready to share." },
        { q: "How do I pay?", a: "Payment is 100% online and secure through Stripe. We accept major credit and debit cards." },
        { q: "Is the song really original?", a: "Absolutely. Each melody and lyric is composed from scratch, inspired solely by the story you share with us." },
        { q: "Can I track my order?", a: "Of course! Message us on WhatsApp anytime and we'll gladly follow up on your order." },
      ],
    },
    footer: {
      title: "Ready to give a melody?",
      desc: "Create a unique, unforgettable song today, or message us on WhatsApp if you have questions.",
      cta: "Create my song",
      rights: "Made with",
    },
    whatsapp: "Message us",
    track: {
      back: "Back to home",
      title: "Track your order",
      subtitle: "Enter your code to see the status and download your song.",
      search: "Search",
      code: "Code",
      client: "Client",
      download: "Download my song (MP3)",
      download1: "Download audio 1 (MP3)",
      download2: "Download audio 2 (MP3)",
      downloadKaraoke: "Download karaoke video (MP4)",
      karaokePending: "Your karaoke video will be available very soon 🎬",
      inProduction: "Your song is in production 🎶",
      comeBack: "Come back soon or message us on WhatsApp.",
      contact: "Contact",
      notFound: "Order not found.",
      status: { nuevo: "Received", en_proceso: "In production", en_revision: "Under review", entregado: "Ready to download!" },
      progressTitle: "Your order progress",
      currentStage: "Current stage",
      stages: {
        pedido_realizado: "Order placed",
        escribiendo_letra: "Writing the lyrics",
        letra_entregada: "Lyrics delivered",
        revision_letra: "Lyrics review",
        letra_aprobada: "Lyrics approved",
        creando_melodia: "Creating & recording the melody",
        cancion_entregada: "Song delivered",
      },
      dlError: "Your song isn't ready to download yet.",
      dlErrorKaraoke: "Your karaoke video isn't ready to download yet.",
    },
    success: {
      checking: "Confirming your payment...",
      wait: "One moment please.",
      title: "Payment confirmed! 🎉",
      thanks: "Thank you for your purchase",
      willStart: "We'll start creating your melody very soon.",
      yourCode: "Your tracking code",
      trackLink: "Track and download my song →",
      wa: "Follow up on WhatsApp",
      failTitle: "We couldn't confirm the payment",
      failDesc: "If you think this is a mistake, contact us on WhatsApp.",
      home: "Back to home",
    },
    cancel: {
      title: "Payment cancelled",
      desc: "Don't worry, no charge was made. You can try again whenever you want.",
      retry: "Try again",
    },
    review: {
      back: "Back to home",
      title: "Leave us a review",
      subtitle: "Your review will appear in our Real Stories section 💕",
      code: "Your order code",
      codePh: "e.g. A1B2C3",
      codeHelp: "Find it in your confirmation email or in the Track order section.",
      codeRequired: "Enter your order code",
      rating: "How would you rate your experience?",
      name: "Your name",
      occasion: "Occasion (optional)",
      occasionPh: "E.g. Birthday, Anniversary...",
      message: "Your review",
      messagePh: "Tell us what you thought of your song...",
      submit: "Send my review",
      required: "Please enter your name and review",
      error: "We couldn't submit your review. Please try again.",
      thanksTitle: "Thank you for your review!",
      thanksText: "Your story is now part of Regala Una Melodía. 🎶",
      goHome: "Back to home",
    },
  },
};

const detectInitialLang = () => {
  const saved = localStorage.getItem("rum_lang");
  if (saved === "es" || saved === "en") return saved;
  const langs = navigator.languages || [navigator.language || "es"];
  const prefersSpanish = langs.some((l) => (l || "").toLowerCase().startsWith("es"));
  return prefersSpanish ? "es" : "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detectInitialLang);

  useEffect(() => {
    localStorage.setItem("rum_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = () => setLang((l) => (l === "es" ? "en" : "es"));
  const t = (path) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), dict[lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
